import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/base/base.component';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Automapper } from 'src/infrastructure/core/automapper';
import { Successes } from 'src/infrastructure/labels/successes';
import { updateUserRequestModel } from 'src/models/requestModels/user/updateUserRequestModel';
import { HistoryService } from 'src/services/state/history/history.service';

@Component({
  selector: 'app-accountsettings',
  templateUrl: './accountsettings.component.html',
  styleUrls: ['./accountsettings.component.css']
})
export class AccountsettingsComponent extends HistoryBaseComponent implements OnInit {

  constructor(
    private router: Router,
    protected location: Location,
    protected historyService: HistoryService

  ) {
    super(location, historyService);
    this._pageTitle = 'settings';
  }

  ngOnInit(): void {
  }

  onAutomaticShareChange(event: any) {
    const isAutomaticShareChecked = event.target.checked;

    // Talk for in ussue to update AutomaticShare

    // if (!this._switchTouched) {
    //   this._switchTouched = true;
    //   return;
    // }
    // const automaticShareValue = event.value;
    // let userUpdateModel: updateUserRequestModel = {} as any;
    // Automapper.ModelToModel.map(this._loggedUser, userUpdateModel);
    // userUpdateModel.orderSharedAutomatically = automaticShareValue;
    // this.userInfoService.updateUser(userUpdateModel).subscribe(() => {
    //   this.toast.success(Successes.bg.updateUser);
    // })
  }

  onChangePasswordTap() {
    this.router.navigate(['user/changepassword']);
  }

}
